import { render } from "./SuratTugasViewer.vue?vue&type=template&id=78c0f50e&scoped=true"
import script from "./SuratTugasViewer.vue?vue&type=script&lang=js"
export * from "./SuratTugasViewer.vue?vue&type=script&lang=js"

import "./SuratTugasViewer.vue?vue&type=style&index=0&id=78c0f50e&lang=scss&scoped=true"

import exportComponent from "/Users/mymac/Documents/Digitala/Perki/newest-perki/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78c0f50e"]])

export default __exports__